<template>
  <div class="bt-noti-wrap noti-two-col">
    <div v-if="isTvingPartner" class="bt-noti">
      <p class="bt-noti-tit">더블 이용권 이용 주의사항</p>
      <p
        v-for="tvingCaution in CAUTIONS_FOR_TVING_PARTNER"
        :key="tvingCaution"
        class="dot-text"
      >
        <span
          v-html="
            getTextBreaks(
              getTextLinks(tvingCaution, CAUTIONS_FOR_TVING_PARTNER_LINKS),
            )
          "
        ></span>
      </p>
    </div>

    <div class="bt-noti">
      <p class="bt-noti-tit">서비스 이용 주의사항</p>
      <p
        v-for="serviceCaution in CAUTIONS_FOR_SERVICE"
        :key="serviceCaution"
        class="dot-text"
      >
        <span
          v-html="
            getTextBreaks(
              getTextLinks(serviceCaution, CAUTIONS_FOR_SERVICE_LINKS),
            )
          "
        ></span>
      </p>
    </div>

    <div class="bt-noti">
      <p class="bt-noti-tit">서비스 이용 권장사항</p>
      <p
        v-for="recommendation in RECOMMENDATION_FOR_SERVICE"
        :key="recommendation"
        class="dot-text"
      >
        <span v-html="getTextBreaks(recommendation)"></span>
      </p>
    </div>
    <div class="bt-noti">
      <p class="bt-noti-tit">이용권 구매 주의사항</p>
      <p
        v-for="caution in CAUTIONS_FOR_PURCHASE"
        :key="caution"
        class="dot-text"
      >
        <span
          v-html="
            getTextBreaks(getTextLinks(caution, CAUTIONS_FOR_PURCHASE_LINKS))
          "
        >
        </span>
      </p>
    </div>
  </div>
</template>

<script setup>
  import { computed, defineProps } from 'vue'
  import {
    CAUTIONS_FOR_TVING_PARTNER,
    CAUTIONS_FOR_TVING_PARTNER_LINKS,
    CAUTIONS_FOR_SERVICE,
    CAUTIONS_FOR_SERVICE_LINKS,
    RECOMMENDATION_FOR_SERVICE,
    CAUTIONS_FOR_PURCHASE,
    CAUTIONS_FOR_PURCHASE_LINKS,
  } from '@/components/voucher/voucher-text/const'

  import { getTextLinks } from '@/common/utils/string-manipulation/get-text-links'
  import { getTextBreaks } from '@/common/utils/string-manipulation/get-text-breaks'
  import { VOUCHER_TYPE } from '@/components/voucher/partner/const'

  const props = defineProps({
    voucherType: {
      type: String,
      default: '',
    },
  })

  const isTvingPartner = computed(
    () => props.voucherType === VOUCHER_TYPE.TVING_PARTNER,
  )
</script>
